import { j as c } from "./jsx-runtime-3tyXYecC.mjs";
import { f as a } from "./index-LyFokDcn.mjs";
import * as S from "react";
import v, { createContext as T, useContext as V, useState as z, forwardRef as E } from "react";
import { D as I, b as C, c as D, u as H, m as b } from "./tss-DN0acMKN.mjs";
import { M as w, d as k } from "./constants-CnFYFetN.mjs";
import { g as Q, c as U } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { s as G, u as O, c as Z } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { m as X } from "./memoTheme-BzXKG_-k.mjs";
import { c as q } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { g as J } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { T as K } from "./Typography-DfkimCSn.mjs";
import { i as W } from "./isFocusVisible-CLflI_-N.mjs";
import { F as Y } from "./flex-Cc3osQLf.mjs";
import { B as ee } from "./base-icon-v2-DZwX3wnO.mjs";
import { T as oe } from "./text-field-ZOMRKQAY.mjs";
import { I as re } from "./icon-button-BxDvkq_l.mjs";
import { I as A } from "./InputAdornment-T4xPPRnD.mjs";
import { I as ne } from "./MagGlass16x16-C5rwnQuW.mjs";
import { I as te } from "./icon-v2-DGtVEk7e.mjs";
import { L as ae } from "./link-unstyled-CvXR-8s6.mjs";
import { T as ie } from "./tooltip-Cy1xtUCm.mjs";
function se(e) {
  return Q("MuiLink", e);
}
const le = J("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), ce = ({
  theme: e,
  ownerState: r
}) => {
  const o = r.color, t = I(e, `palette.${o}`, !1) || r.color, s = I(e, `palette.${o}Channel`);
  return "vars" in e && s ? `rgba(${s} / 0.4)` : C(t, 0.4);
}, B = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, de = (e) => {
  const {
    classes: r,
    component: o,
    focusVisible: t,
    underline: s
  } = e, i = {
    root: ["root", `underline${D(s)}`, o === "button" && "button", t && "focusVisible"]
  };
  return Z(i, se, r);
}, ue = G(K, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (e, r) => {
    const {
      ownerState: o
    } = e;
    return [r.root, r[`underline${D(o.underline)}`], o.component === "button" && r.button];
  }
})(X(({
  theme: e
}) => ({
  variants: [{
    props: {
      underline: "none"
    },
    style: {
      textDecoration: "none"
    }
  }, {
    props: {
      underline: "hover"
    },
    style: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  }, {
    props: {
      underline: "always"
    },
    style: {
      textDecoration: "underline",
      "&:hover": {
        textDecorationColor: "inherit"
      }
    }
  }, {
    props: ({
      underline: r,
      ownerState: o
    }) => r === "always" && o.color !== "inherit",
    style: {
      textDecorationColor: "var(--Link-underlineColor)"
    }
  }, ...Object.entries(e.palette).filter(q()).map(([r]) => ({
    props: {
      underline: "always",
      color: r
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.4)` : C(e.palette[r].main, 0.4)
    }
  })), {
    props: {
      underline: "always",
      color: "textPrimary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : C(e.palette.text.primary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textSecondary"
    },
    style: {
      "--Link-underlineColor": e.vars ? `rgba(${e.vars.palette.text.secondaryChannel} / 0.4)` : C(e.palette.text.secondary, 0.4)
    }
  }, {
    props: {
      underline: "always",
      color: "textDisabled"
    },
    style: {
      "--Link-underlineColor": (e.vars || e).palette.text.disabled
    }
  }, {
    props: {
      component: "button"
    },
    style: {
      position: "relative",
      WebkitTapHighlightColor: "transparent",
      backgroundColor: "transparent",
      // Reset default value
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      border: 0,
      margin: 0,
      // Remove the margin in Safari
      borderRadius: 0,
      padding: 0,
      // Remove the padding in Firefox
      cursor: "pointer",
      userSelect: "none",
      verticalAlign: "middle",
      MozAppearance: "none",
      // Reset
      WebkitAppearance: "none",
      // Reset
      "&::-moz-focus-inner": {
        borderStyle: "none"
        // Remove Firefox dotted outline.
      },
      [`&.${le.focusVisible}`]: {
        outline: "auto"
      }
    }
  }]
}))), fe = /* @__PURE__ */ S.forwardRef(function(r, o) {
  const t = O({
    props: r,
    name: "MuiLink"
  }), s = H(), {
    className: i,
    color: n = "primary",
    component: u = "a",
    onBlur: l,
    onFocus: f,
    TypographyClasses: h,
    underline: p = "always",
    variant: x = "inherit",
    sx: d,
    ...m
  } = t, [g, L] = S.useState(!1), M = (y) => {
    W(y.target) || L(!1), l && l(y);
  }, P = (y) => {
    W(y.target) && L(!0), f && f(y);
  }, F = {
    ...t,
    color: n,
    component: u,
    focusVisible: g,
    underline: p,
    variant: x
  }, _ = de(F);
  return /* @__PURE__ */ c.jsx(ue, {
    color: n,
    className: U(_.root, i),
    classes: h,
    component: u,
    onBlur: M,
    onFocus: P,
    ref: o,
    ownerState: F,
    variant: x,
    ...m,
    sx: [...B[n] === void 0 ? [{
      color: n
    }] : [], ...Array.isArray(d) ? d : [d]],
    style: {
      ...m.style,
      ...p === "always" && n !== "inherit" && !B[n] && {
        "--Link-underlineColor": ce({
          theme: s,
          ownerState: F
        })
      }
    }
  });
}), R = (e) => v.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 16", width: "16", height: "16" }, e),
  v.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    v.createElement(
      "g",
      { fillRule: "nonzero" },
      v.createElement("path", { d: "M1369,372 C1364.582,372 1361,375.582 1361,380 C1361,384.418 1364.582,388 1369,388 C1373.418,388 1377,384.418 1377,380 C1377,375.582 1373.418,372 1369,372 Z M1372.138,382.195333 C1372.39867,382.456 1372.39867,382.877333 1372.138,383.138 C1372.008,383.268 1371.83733,383.333333 1371.66667,383.333333 C1371.496,383.333333 1371.32533,383.268 1371.19533,383.138 L1369,380.942667 L1366.80467,383.138 C1366.67467,383.268 1366.504,383.333333 1366.33333,383.333333 C1366.16267,383.333333 1365.992,383.268 1365.862,383.138 C1365.60133,382.877333 1365.60133,382.456 1365.862,382.195333 L1368.05733,380 L1365.862,377.804667 C1365.60133,377.544 1365.60133,377.122667 1365.862,376.862 C1366.12267,376.601333 1366.544,376.601333 1366.80467,376.862 L1369,379.057333 L1371.19533,376.862 C1371.456,376.601333 1371.87733,376.601333 1372.138,376.862 C1372.39867,377.122667 1372.39867,377.544 1372.138,377.804667 L1369.94267,380 L1372.138,382.195333 Z", transform: "translate(-1361 -372)" })
    )
  )
);
R.displayName = "CircleX16x16";
const N = T({ dark: !1 }), pe = b()(({ breakpoints: e, mode: r, palette: o, spacing: t, typography: s }, { active: i, dark: n }) => {
  let u = n ? o.common.white : o.gray[700], l = "transparent";
  return i && (l = n ? o.gray[800] : o.gray[100], u = n ? o.common.white : o.primary.main), {
    root: {
      alignItems: "center",
      backgroundColor: l,
      borderRadius: "unset",
      color: u,
      display: "inline-flex",
      fontSize: s.fabricFontSize("large"),
      fontWeight: i ? s.fontWeightBold : s.fontWeightMedium,
      height: "100%",
      outline: r === w.Dye ? `1px solid ${k.main}` : void 0,
      padding: t(0, 2),
      textDecoration: "none",
      transition: "padding 0.2s ease-in-out",
      whiteSpace: "nowrap",
      "&:after": {
        color: "transparent",
        display: i ? "block" : "none",
        fontWeight: s.fontWeightBold,
        position: "absolute",
        content: "attr(data-text)"
      },
      "&:hover": {
        backgroundColor: n ? o.gray[800] : o.gray[100],
        color: n ? o.common.white : o.primary.main,
        textDecoration: "none"
      },
      [e.up("xl")]: {
        padding: "0 20px"
      }
    }
  };
}), me = (e) => {
  const { dark: r } = V(N), { active: o, children: t, classes: s, ...i } = e, { classes: n } = pe({ active: o, dark: r }, { props: { classes: s } });
  return /* @__PURE__ */ c.jsx(fe, { classes: s, className: n.root, "data-text": t, ...i, children: t });
}, he = b()(({ borderRadiuses: e, mixins: r, mode: o, spacing: t, typography: s, constructs: i }, { active: n, disabled: u, focused: l }) => {
  const f = o === w.Dye ? k.main : i.icon.primary.strong;
  let h = i.icon.neutral.xStrong, p, x, d, m = i.surface.neutral.forcedWhite, g = f;
  return u ? (h = i.surface.neutral.strong, m = "unset", g = i.surface.neutral.strong, p = "unset !important") : n || l ? (h = f, p = "pointer", x = i.surface.neutral.xWeak, d = s.fontWeightBold, m = i.surface.neutral.xWeak, g = f) : (p = "pointer", m = i.surface.neutral.xWeak), {
    root: {
      alignItems: "center",
      backgroundColor: x,
      border: "none",
      borderRadius: e[200],
      boxSizing: "border-box",
      color: h,
      cursor: p,
      display: "inline-flex",
      fill: h,
      fontWeight: d,
      gap: t(1.5),
      marginLeft: "0",
      padding: t(1),
      textIndent: "0",
      "&:hover": {
        backgroundColor: m,
        borderRadius: e[200],
        color: g,
        fill: g,
        textDecoration: "none"
      },
      "&:focus-visible": {
        borderRadius: e[200],
        boxShadow: `0px 0px 0px 2px ${r.alpha(i.surface.primary.strong, 0.8)}`
      }
    }
  };
});
function ge(e) {
  const { active: r, activeIcon: o, children: t, component: s = "a", disabled: i = !1, focused: n = !1, icon: u, label: l, ...f } = e, { classes: h } = he({ active: r, disabled: i, focused: n }), p = r && o ? o : u, x = "href" in e && !i ? e.href : void 0, [d, m] = z(null);
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    l ? /* @__PURE__ */ c.jsx(ie, { anchorEl: d, content: l, enterDelay: 2e3, placement: "bottom" }) : null,
    /* @__PURE__ */ c.jsxs(
      ae,
      {
        "aria-label": l || (window.jQuery ? $.__("action link") : "action link"),
        className: h.root,
        component: s,
        containerRef: m,
        href: x,
        ...f,
        children: [
          typeof p == "string" && /* @__PURE__ */ c.jsx(te, { name: p, size: 24 }),
          t
        ]
      }
    )
  ] });
}
const xe = b()(({ palette: e }) => ({
  clearIcon: {
    fill: e.gray[600]
  }
})), ye = ({ onClear: e }) => {
  const { classes: r } = xe();
  return /* @__PURE__ */ c.jsx(
    re,
    {
      "aria-label": window.jQuery ? $.__("Clear Search") : "Clear Search",
      floatingIcon: !0,
      hasBounding: !1,
      icon: a.ifFeature("encore", "circle-xmark-solid", /* @__PURE__ */ c.jsx(R, { className: r.clearIcon })),
      onMouseDown: (o) => {
        o.stopPropagation(), o.preventDefault(), typeof e == "function" && e();
      },
      type: "button"
    }
  );
}, be = b()(({ breakpoints: e, mixins: r, mode: o, palette: t, spacing: s }, { value: i }, n) => ({
  root: {
    width: a.ifFeature("encore", "288px"),
    // @startCleanup encore
    boxShadow: a.ifFeature("encore", void 0, "none"),
    // @endCleanup encore
    borderRadius: 18,
    borderColor: a.ifFeature("encore", t.grey[400]),
    outline: o === w.Dye ? `1px solid ${k.main}` : void 0,
    overflow: "hidden",
    transition: "all 0.2s ease-in-out",
    // @startCleanup encore
    maxWidth: a.ifFeature("encore", void 0, 160),
    // @endCleanup encore
    flexGrow: a.ifFeature("encore", 1),
    padding: a.ifFeature("encore", s(1, 1, 1, 2)),
    [`&:focus-within, &.${n.focus}`]: {
      // @startCleanup encore
      maxWidth: a.ifFeature("encore", void 0, 228),
      [`& .${n.searchAdornment}`]: {
        backgroundColor: a.ifFeature("encore", void 0, t.gray[100])
      },
      // @endCleanup encore
      [`& .${n.searchIcon}`]: {
        fill: t.primary.main
      }
    },
    [`& .${n.clearAdornment}`]: {
      backgroundColor: "transparent"
    },
    [`& .${n.searchAdornment}`]: {
      backgroundColor: "transparent"
    },
    // @startCleanup encore
    [e.down("md")]: {
      maxWidth: a.ifFeature("encore", void 0, 46),
      [`&:focus-within, &.${n.focus}`]: {
        maxWidth: a.ifFeature("encore", void 0, 228)
      },
      [`&:not(:focus-within):not(&.${n.focus}) .${n.searchAdornment}`]: {
        marginLeft: a.ifFeature("encore", void 0, "-4px")
      }
    }
    // @endCleanup encore
  },
  clearAdornment: {
    opacity: i ? 1 : 0,
    transition: "opacity 0.2s ease-in-out"
  },
  focus: {
    "&, &:hover": {
      ...r.focusRing(t.primary)
    }
  },
  searchAdornment: {},
  searchIcon: {
    fill: t.gray[600],
    width: a.ifFeature("encore", "12px")
  },
  decoy: {
    width: 0,
    height: 0,
    visibility: "hidden",
    position: "absolute",
    left: 0,
    top: 0,
    padding: 0,
    border: "none",
    margin: 0
  }
})), ve = E((e, r) => {
  const {
    classes: o,
    hasVisibleResults: t,
    placeholder: s = window.jQuery ? $.__("Search...") : "Search...",
    onClear: i,
    value: n,
    ...u
  } = e, { classes: l, cx: f } = be({ value: n }, { props: { classes: o } });
  return /* @__PURE__ */ c.jsx(
    oe,
    {
      classes: o,
      id: "global-search-header-input",
      InputProps: {
        ariaLabel: window.jQuery ? $.__("Search") : "Search",
        autoComplete: "off",
        classes: { root: f(l.root, { [l.focus]: t }) },
        denseAdornment: a.ifFeature("encore", !0),
        endAdornment: /* @__PURE__ */ c.jsx(A, { className: l.clearAdornment, position: "end", children: /* @__PURE__ */ c.jsx(ye, { onClear: i }) }),
        startAdornment: /* @__PURE__ */ c.jsx(A, { className: l.searchAdornment, disablePointerEvents: !0, position: "start", children: a.ifFeature(
          "encore",
          /* @__PURE__ */ c.jsx(ee, { className: l.searchIcon, name: "magnifying-glass-regular" }),
          /* @__PURE__ */ c.jsx(ne, { "aria-hidden": !0, className: l.searchIcon })
        ) })
      },
      name: "Global Search",
      placeholder: s,
      ref: r,
      size: a.ifFeature("encore", "medium", "large"),
      value: n,
      ...u
    }
  );
}), Ce = b()(({ mixins: e, mode: r, palette: o, spacing: t, typography: s, constructs: i }, { borderBottom: n, dark: u, position: l, children: f, actions: h }) => {
  const p = u ? o.gray[900] : o.gray[200];
  return {
    guts: {
      alignItems: "center",
      backgroundColor: a.ifFeature("encore", void 0, p),
      borderBottom: a.ifFeature("encore", "1px solid transparent"),
      boxShadow: a.ifFeature("encore", "0 0 transparent"),
      transition: "border-bottom 0.3s ease-out, box-shadow 0.3s ease-out",
      boxSizing: a.ifFeature("encore", "content-box", "border-box"),
      display: "flex",
      gap: a.ifFeature("encore", t(2), void 0),
      fontWeight: s.fontWeightMedium,
      height: a.ifFeature("encore", 42, 80),
      minWidth: 1124,
      justifyContent: a.ifFeature("encore", "space-between", void 0),
      overflow: a.ifFeature("encore", "visible", "hidden"),
      position: l === "fixed" || l === "sticky" ? l : "relative",
      paddingTop: a.ifFeature("encore", t(3), void 0),
      paddingBottom: a.ifFeature("encore", t(3), 3),
      paddingLeft: a.ifFeature("encore", 0, t(4)),
      paddingRight: a.ifFeature("encore", 0, t(4)),
      "&:after": {
        backgroundImage: a.ifFeature(
          "encore",
          void 0,
          `linear-gradient(90deg, ${o.primary.lightest} 0, ${o.primary.lighter} 100%)`
        ),
        bottom: 0,
        content: '""',
        display: "block",
        height: 3,
        left: 0,
        position: "absolute",
        width: "100%"
      },
      ...l === "fixed" ? {
        left: 0,
        right: 0,
        top: 0
      } : {}
    },
    gutsBorder: {
      borderBottom: n ? a.ifFeature("encore", `1px solid ${e.alpha(i.border.neutral.strong, 0.2)}`) : void 0,
      boxShadow: n ? a.ifFeature("encore", `0 2px 1px -1px ${e.alpha(i.border.neutral.strong, 0.05)}`) : void 0
    },
    logo: {
      display: "flex"
    },
    nav: {
      display: "flex",
      flexGrow: 1,
      height: "100%",
      marginLeft: t(4.5),
      overflow: "hidden",
      position: "relative",
      "&:after": {
        backgroundImage: u ? `linear-gradient(270deg, ${e.alpha(o.gray[900], 1)} 55%, ${e.alpha(o.gray[900], 0)})` : `linear-gradient(270deg, ${e.alpha(o.gray[200], 1)} 55%, ${e.alpha(o.gray[200], 0)})`,
        content: '""',
        display: "block",
        position: "absolute",
        right: -40,
        top: 0,
        bottom: 0,
        width: 110
      }
    },
    root: {
      outline: r === w.Dye ? `2px solid ${k.main}` : void 0
    },
    search: {
      marginLeft: a.ifFeature("encore", "auto", void 0)
    },
    spacer: {
      height: 80
    }
  };
}), j = (e) => {
  const {
    actions: r,
    borderBottom: o = !1,
    children: t,
    className: s = "",
    classes: i,
    dark: n,
    logo: u,
    position: l,
    nav: f,
    search: h,
    title: p,
    ...x
  } = e, { classes: d, cx: m } = Ce({ actions: r, children: t, dark: n, position: l, borderBottom: o }, { props: { classes: i } });
  return /* @__PURE__ */ c.jsx(N.Provider, { value: { dark: n }, children: /* @__PURE__ */ c.jsxs(
    "header",
    {
      ...x,
      className: m(s, d.root),
      "data-fabric-component": "Header",
      ref: (g) => document.documentElement.style.setProperty("--fabric-global-header-height", `${(g == null ? void 0 : g.offsetHeight) ?? 0}px`),
      children: [
        /* @__PURE__ */ c.jsxs("div", { className: m(d.guts, o ? d.gutsBorder : ""), children: [
          /* @__PURE__ */ c.jsx("a", { "aria-label": window.jQuery ? $.__("Logo") : "Logo", className: d.logo, href: "/", children: u }),
          p,
          a.ifFeature("encore", void 0, /* @__PURE__ */ c.jsx("nav", { className: d.nav, children: f })),
          /* @__PURE__ */ c.jsx("div", { className: d.search, children: h }),
          /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            t,
            a.ifFeature(
              "encore",
              r != null && r.length ? /* @__PURE__ */ c.jsx(Y, { alignItems: "center", gap: 1, justifyContent: "center", children: r }) : null
            )
          ] })
        ] }),
        l === "fixed" && /* @__PURE__ */ c.jsx("div", { className: d.spacer })
      ]
    }
  ) });
};
j.Link = me;
j.SearchInput = ve;
j.Action = ge;
export {
  ge as A,
  j as H,
  me as L,
  ve as S
};
//# sourceMappingURL=header-C0j1k0Y4.mjs.map
